import React from "react";
import { MapPin, Square, Layers, Box, Image } from "lucide-react";
import { CampaignItem } from "./index";
import { ProfileCardBase } from "./profile-card-base";

interface LocationCardProps {
  item: CampaignItem;
}

export function LocationCard({ item }: LocationCardProps) {
  const formatSurface = (surface?: number) => {
    if (!surface) return "N.C.";
    return `${surface}m2`;
  };

  const formatWindow = (window?: number) => {
    if (!window) return "N.C.";
    return `${window}m`;
  };

  const formatSidewalk = (sidewalk?: number) => {
    if (!sidewalk) return "N.C.";
    return `${sidewalk}m2`;
  };

  return (
    <ProfileCardBase
      name={item.name}
      logoUrl={item.logo_url}
      fallbackIcon={Image}
      profileId={item.id}
      profileType="Location"
      userId={item.user_id}
      entity={item}
      items={[
        {
          icon: MapPin,
          label: "Localisation",
          value: item.address || "N.C.",
        },
        {
          icon: Square,
          label: "Surface",
          value: formatSurface(item.surface),
        },
        {
          icon: Layers,
          label: "Vitrine",
          value: formatWindow(item.window),
        },
        {
          icon: Box,
          label: "Trottoir",
          value: formatSidewalk(item.sidewalk_width),
        },
      ]}
    />
  );
}
